import { Button, Stack, styled } from '@mui/material'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { useLinkConnected } from 'store/link/hooks'
import { updateModal } from '../../../store/app/actions/modalActions'

const Wrap = styled(Stack)`
  padding: 8px 0;
  gap: 8px;
`
const StyledButton = styled(Button)`
  height: 32px;
  font-size: 14px;
  color: ${({ theme }) => theme.color.text80};
  background: rgba(42, 49, 57, 1);
  border: none;
  border-radius: 16px;

  &:hover {
    font-weight: 600;
    background: rgba(57, 65, 73, 1);
    color: rgba(160, 238, 9, 1);
  }
`
const DepositButton = styled(StyledButton)`
  flex: 1;
  &.unlink {
    color: rgba(98, 109, 116, 1);
    background-color: rgba(46, 54, 59, 1);
    :hover {
      cursor: default;
    }
  }
`

export const BalanceButtonGroup = memo(() => {
  const dispatch = useDispatch()
  const linkConnected = useLinkConnected()
  return (
    <Wrap>
      <Stack direction="row" spacing={1}>
        <DepositButton
          className={!linkConnected ? 'unlink' : ''}
          onClick={() => {
            if (linkConnected) {
              dispatch(updateModal({ modal: 'deposit', open: true }))
            }
          }}
        >
          Deposit
        </DepositButton>
        <DepositButton
          className={!linkConnected ? 'unlink' : ''}
          onClick={() => {
            if (linkConnected) {
              dispatch(updateModal({ modal: 'withdraw', open: true }))
            }
          }}
        >
          Withdraw
        </DepositButton>
        <DepositButton
          className={!linkConnected ? 'unlink' : ''}
          onClick={() => {
            if (linkConnected) {
              dispatch(updateModal({ modal: 'convert', open: true }))
            }
          }}
        >
          Convert
        </DepositButton>
      </Stack>
    </Wrap>
  )
})
